import { SpacePubliclyTradedCompaniesPage } from "@nvb/ui";
import { usePageContext } from "vike-react/usePageContext";

import type { TPubliclyTradedCompaniesData } from "@nvb/ui";

/**
 * The companies table came from a browser-only fetch, so the prerendered HTML
 * held an empty table. The build-time snapshot travels in
 * `pageContext.initialData` (see `pages/+onBeforeRender.ts`).
 *
 * Prices and market caps in that snapshot are as old as the last build — the
 * page replaces them on mount and refreshes every minute, so only a crawler
 * ever reads the stale numbers.
 */
export default function Page() {
	const { initialData } = usePageContext();

	const companies = (initialData?.publiclyTradedCompanies as { data?: TPubliclyTradedCompaniesData } | undefined)?.data;

	return <SpacePubliclyTradedCompaniesPage {...(companies?.length ? { initialCompanies: companies } : {})} />;
}
